import React from "react";
import { Grid, Typography, Button, Tooltip, Box, Paper } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SaveIcon from "@mui/icons-material/Download";

function ContactCard() {
  const contactMethods = [
    {
      icon: <CallIcon />,
      title: "Call Us",
      href: "tel:+919986460943",
      color: "#3b82f6",
      label: "Call",
    },
    {
      icon: <WhatsAppIcon />,
      title: "Chat on WhatsApp",
      href: "https://wa.me/919986460943",
      color: "#22c55e",
      label: "WhatsApp",
    },
    {
      icon: <EmailIcon />,
      title: "Send an Email",
      href: "mailto:powerelectrocontrolind@gmail.com",
      color: "#ef4444",
      label: "Email",
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        py: 8,
        px: 2,
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Paper
            elevation={0}
            sx={{
              background: "white",
              borderRadius: "24px",
              p: 6,
              border: "1px solid #e2e8f0",
              backdropFilter: "blur(10px)",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
            }}
          >
            {/* Contact Person */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                fontWeight="700"
                sx={{
                  color: "#0f172a",
                  mb: 1,
                  fontSize: { xs: "1.8rem", sm: "2.2rem" },
                }}
              >
                Nazeer AK
              </Typography>
              <Box
                sx={{
                  width: "60px",
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%)",
                  borderRadius: "2px",
                }}
              />
            </Box>

            {/* Phone Numbers */}
            <Box sx={{ mb: 6 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <CallIcon sx={{ color: "#3b82f6", fontSize: "1.5rem" }} />
                <Typography
                  sx={{
                    color: "#0f172a",
                    fontSize: "1rem",
                    fontWeight: "600",
                  }}
                >
                  9986460943
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <CallIcon sx={{ color: "#3b82f6", fontSize: "1.5rem" }} />
                <Typography
                  sx={{
                    color: "#0f172a",
                    fontSize: "1rem",
                    fontWeight: "600",
                  }}
                >
                  9620754954
                </Typography>
              </Box>
            </Box>

            {/* Contact Methods */}
            <Box sx={{ mb: 6 }}>
              <Typography
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  color: "#64748b",
                  mb: 3,
                  letterSpacing: "1px",
                }}
              >
                Quick Contact
              </Typography>
              <Grid container spacing={2}>
                {contactMethods.map((method, index) => (
                  <Grid item xs={6} sm={4} key={index}>
                    <Tooltip title={method.title}>
                      <Box
                        component="a"
                        href={method.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1.5,
                          textDecoration: "none",
                          transition: "all 0.3s ease",
                          "&:hover .icon-wrapper": {
                            transform: "translateY(-4px)",
                            boxShadow: `0 10px 30px ${method.color}40`,
                          },
                        }}
                      >
                        <Box
                          className="icon-wrapper"
                          sx={{
                            width: "60px",
                            height: "60px",
                            background: `${method.color}15`,
                            borderRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: method.color,
                            fontSize: "1.5rem",
                            transition: "all 0.3s ease",
                            border: `2px solid ${method.color}30`,
                          }}
                        >
                          {method.icon}
                        </Box>
                        <Typography
                          sx={{
                            fontSize: "0.875rem",
                            fontWeight: "600",
                            color: "#0f172a",
                            textAlign: "center",
                          }}
                        >
                          {method.label}
                        </Typography>
                      </Box>
                    </Tooltip>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Save Contact Button */}
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              href="/pec.vcf"
              download="pec.vcf"
              sx={{
                width: "100%",
                py: 1.8,
                mb: 4,
                background: "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)",
                color: "white",
                fontSize: "1rem",
                fontWeight: "600",
                borderRadius: "12px",
                textTransform: "none",
                boxShadow: "0 4px 15px rgba(59, 130, 246, 0.4)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(59, 130, 246, 0.5)",
                },
              }}
            >
              Save Contact
            </Button>

            {/* Email and Address */}
            <Box
              sx={{
                background: "#f8fafc",
                borderRadius: "16px",
                p: 3,
                border: "1px solid #e2e8f0",
              }}
            >
              <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
                <EmailIcon sx={{ color: "#ef4444", fontSize: "1.3rem", mt: 0.5 }} />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      color: "#64748b",
                      mb: 0.5,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Email
                  </Typography>
                  <Typography
                    component="a"
                    href="mailto:powerelectrocontrolind@gmail.com"
                    sx={{
                      fontSize: "0.95rem",
                      color: "#0f172a",
                      fontWeight: "500",
                      textDecoration: "none",
                      "&:hover": {
                        color: "#3b82f6",
                      },
                    }}
                  >
                    powerelectrocontrolind@gmail.com
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <LocationOnIcon sx={{ color: "#06b6d4", fontSize: "1.3rem", mt: 0.5 }} />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      color: "#64748b",
                      mb: 0.5,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Address
                  </Typography>
                  <Typography
                    component="a"
                    href="https://www.google.com/maps/search/?api=1&query=Power+Electro+Control+India+Pvt+Ltd,+Bengaluru"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontSize: "0.95rem",
                      color: "#0f172a",
                      fontWeight: "500",
                      textDecoration: "none",
                      cursor: "pointer",
                      "&:hover": {
                        color: "#3b82f6",
                      },
                    }}
                  >
                    #2, Poojari Cheluvaiah Lane, S.J.P. Road Cross, Bengaluru - 560002
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ContactCard;
